import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback, type WidgetErrorProps } from '@/shared/ui/ErrorBoundary';

import { GpuPowerMetric } from '@/widgets/monitoring/GpuPowerMetric';
import { GpuTempMetric } from '@/widgets/monitoring/GpuTempMetric';
import { TensorCoreMetric } from '@/widgets/monitoring/TensorCoreMetric';
import { VramUtilizationMetric } from '@/widgets/monitoring/VramUtilizationMetric';

import styles from './GpuMetrics.module.css';

type GpuMetricsContentProps = {
  selectedWorker: string;
};

const Content = ({ selectedWorker }: GpuMetricsContentProps) => {
  return (
    <div className={styles.gpuSection}>
      <div className={styles.row}>
        <ErrorBoundary
          FallbackComponent={(props) => (
            <GpuTempMetric.Error
              {...props}
              title="GPU 온도 오류"
              description="GPU 온도 데이터를 불러오는 중 오류가 발생했습니다."
            />
          )}>
          <GpuTempMetric.Content selectedWorker={selectedWorker} />
        </ErrorBoundary>

        <ErrorBoundary
          FallbackComponent={(props) => (
            <GpuPowerMetric.Error
              {...props}
              title="GPU 전력 오류"
              description="GPU 전력 데이터를 불러오는 중 오류가 발생했습니다."
            />
          )}>
          <GpuPowerMetric.Content selectedWorker={selectedWorker} />
        </ErrorBoundary>
      </div>

      <div className={styles.row}>
        <ErrorBoundary
          FallbackComponent={(props) => (
            <TensorCoreMetric.Error
              {...props}
              title="Tensor Core 오류"
              description="Tensor Core 데이터를 불러오는 중 오류가 발생했습니다."
            />
          )}>
          <TensorCoreMetric.Content selectedWorker={selectedWorker} />
        </ErrorBoundary>

        <ErrorBoundary
          FallbackComponent={(props) => (
            <VramUtilizationMetric.Error
              {...props}
              title="VRAM 사용률 오류"
              description="VRAM 사용률 데이터를 불러오는 중 오류가 발생했습니다."
            />
          )}>
          <VramUtilizationMetric.Content selectedWorker={selectedWorker} />
        </ErrorBoundary>
      </div>
    </div>
  );
};

const Error = ({ title, description, ...props }: WidgetErrorProps) => {
  return <ErrorFallback title={title} description={description} className={styles.error} {...props} />;
};

export const GpuMetrics = { Content, Error };
